import {Util} from 'yougile-util'

export const ffNativeWs = 'ff_native_ws'
export const experimental = 'experimental'
export const ffColumnVirt = 'ff_col_virt'
export const ffMirrors = 'ff_mirrors'
export const ffLazyLoading = 'ff_lazy_loading_new'

const mapFeatures = new Map<string, boolean>()

// в localStorage можно хранить флаги фичей через точку запятую
// features: ff_mirrors;ff_ids;ff_col_virt
export const hasFeatureFlag = (flag: string): boolean => {
  if (mapFeatures.get(flag)) {
    return true
  }

  if (typeof window !== 'undefined') {
    const features = window.localStorage.getItem('features')
    if (features?.split(';').includes(flag)) {
      mapFeatures.set(flag, true)
      return true
    }
  }

  if (typeof document !== 'undefined') {
    const res = new URL(document.location.href).searchParams.has(flag)
    if (res) {
      mapFeatures.set(flag, true)
    }
    return res
  }

  return false
}

export const isTestEnv = (): boolean =>
  !isStandalone() && !Util.isDesktop() && isTestHost()

export const isWebProdEnv = (): boolean =>
  !isStandalone() && !Util.isDesktop() && !isTestHost()

const isTestHost = (): boolean =>
  location.host.startsWith('test-') ||
  location.host.startsWith('test.') ||
  location.host.startsWith('localhost')

export const isStandalone = (): boolean => 'standaloneMode' in window
